import { FC } from 'react'
import EditStatisticPage from './editStatisticPage'

const StatisticMain: FC = () => {
  return <EditStatisticPage className='mb-5 mb-xl-8' />
}

export { StatisticMain }
